// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomerAccess } from '@shared/commons/CustomerAccess/CustomerAccess';
import { PanelDisplayMode } from '@shared/commons/CustomerAccess/PanelDisplayMode';
import { Factory, ThrottlingOperation } from '../panels/Factory';
export function IsAllowedPanel(panel) {
    const panelType = panel.getType();
    const isAllowedByDisplayMode = CustomerAccess.GetDisplayMode(panelType) === PanelDisplayMode.Allowed; // rule check
    const isAllowedByLimit = Factory.GetThrottlingOperationValue(panelType).throttlingOperation === ThrottlingOperation.CanAddPanel; // panels limit number check
    return isAllowedByDisplayMode && isAllowedByLimit;
}
